import countryCoordinates from './country-coordinates.json'

export const getCountryCoordinates = countryName => {
  const { latitude, longitude } = countryCoordinates.countries.find(c => c.country.includes(countryName))

  return [longitude, latitude]
}
